import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitialState {
  customerID: string;
  email: string;
  currentActiveTenantID: string;
  currentActiveTenantName: string;
  allTenants: any[];
  tenantChanged: boolean;
}

const initialState: InitialState = {
  customerID: '',
  email: '',
  currentActiveTenantID: '',
  currentActiveTenantName: '',
  allTenants: [],
  tenantChanged: false,
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    updateCustomer: (state, action: PayloadAction<any>) => {
      state.customerID = action.payload?.customer_id;
      state.email = action.payload?.email;
      state.currentActiveTenantID = action.payload?.current_active_tenant_id;
    },
    updateCurrentTenantName: (state, action: PayloadAction<any>) => {
      state.currentActiveTenantName = action.payload;
    },
    updateAllTenants: (state, action: PayloadAction<any>) => {
      state.allTenants = action.payload;
    },
    updateTenantChangedStatus: (state, action: PayloadAction<any>) => {
      state.tenantChanged = action.payload;
    },
  },
});
export const {
  updateCustomer,
  updateCurrentTenantName,
  updateAllTenants,
  updateTenantChangedStatus,
} = customerSlice.actions;
export default customerSlice;
